import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import logo from '../../assets/teamly.png';
import SuperAdminSidebar from './SuperAdminSidebar';
import { Button } from '../ui/button';
import { Menu, X } from 'lucide-react';
import { cn } from '../../lib/utils';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from '../ui/sheet';

const SuperAdminLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-border h-14 flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-8 w-auto object-contain" />
        </div>

        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-10 w-10"
            >
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-64 border-none">
            <SuperAdminSidebar
              mobile
              onMobileClose={() => setMobileMenuOpen(false)}
            />
          </SheetContent>
        </Sheet>
      </div>

      {/* Sidebar Wrapper */}
      {!mobileMenuOpen && (
        <div className={cn(
          "hidden lg:block h-screen sticky top-0 transition-all duration-300",
          sidebarCollapsed ? "w-[70px]" : "w-[280px]"
        )}>
          <SuperAdminSidebar 
            collapsed={sidebarCollapsed}
            setCollapsed={setSidebarCollapsed}
          />
        </div>
      )}

      {/* Main Content Area */}
      <main className="flex-1 min-h-screen lg:pt-0 pt-14 flex flex-col">
        <div className="p-4 sm:p-6 lg:p-8 flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperAdminLayout;
